import { render, staticRenderFns } from "./mainEntrance.vue?vue&type=template&id=7fbeb48a&scoped=true&"
import script from "./mainEntrance.vue?vue&type=script&lang=js&"
export * from "./mainEntrance.vue?vue&type=script&lang=js&"
import style0 from "./mainEntrance.vue?vue&type=style&index=0&id=7fbeb48a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbeb48a",
  null
  
)

export default component.exports